import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import { TranslationContext } from "../../../umbilical_tools";
import _ from "lodash";
import jssVariables from "../../../jss_setup";

const contactUsStyles = createUseStyles({
  info: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    margin: "0 5vw",
    marginBottom: "5vw",
    ..._.get(props, "customStyles.info", {}),
  }),
  header: (props) => ({
    ..._.get(props, "customStyles.header", {}),
  }),
  text: (props) => ({
    fontSize: "large",
    ..._.get(props, "customStyles.text", {}),
  }),
  anchor: (props) => ({
    border: `2px solid ${jssVariables.colors.base_color}`,
    color: jssVariables.colors.base_color,
    padding: jssVariables.normal_gap,
    borderRadius: "5px",
    textAlign: "center",
    ..._.get(props, "customStyles.anchor", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    info: (props) => ({
      margin: jssVariables.spacing.center_margin_large,
      marginTop: "2vw",
      marginBottom: "5vw",
      ..._.get(props, "customStyles.info.smallscreen", {}),
    }),
  },
});
const ContactUs = (props) => {
  const { contactEmail, customStyles } = props;
  const classes = contactUsStyles({ customStyles });
  const { t } = useContext(TranslationContext);

  return (
    <div className={classes.info}>
      <h4 className={classes.header}>{t("contactUs")}</h4>
      <p className={classes.text}>{t("contactUsText")}</p>
      <a className={classes.anchor} href={`mailto:${contactEmail}`}>
        <strong>{t("dropUsAnEmail")}</strong>
      </a>
    </div>
  );
};
ContactUs.defaultProps = {
  contactEmail: "",
  customStyles: {},
};
ContactUs.propTypes = {
  contactEmail: PropTypes.string.isRequired,
  customStyles: PropTypes.object.isRequired,
};

export default ContactUs;
